import SimpleCarousel from './components';

export default SimpleCarousel;



// WEBPACK FOOTER //
// ./src/components/SimpleCarousel/index.js